import { render, staticRenderFns } from "./Country.vue?vue&type=template&id=ab64683e&"
import script from "./Country.vue?vue&type=script&lang=js&"
export * from "./Country.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports